import { render, staticRenderFns } from "./SkeletonRompeNav.vue?vue&type=template&id=2a11d2b0"
var script = {}
import style0 from "./SkeletonRompeNav.vue?vue&type=style&index=0&id=2a11d2b0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports